var map = {
	"./heart.png": 689,
	"./heart.webp": 464,
	"./message.png": 690,
	"./message.webp": 465,
	"./star.png": 691,
	"./star.webp": 466,
	"./wallet.png": 467,
	"./wallet.webp": 468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 688;